import { useField } from 'formik';
import React from 'react';
import { toast } from 'react-toastify';
import { FormField, FormHelp, Input, Label } from '@zillow/constellation';
import styled from 'styled-components';

export interface IAccountNumberProps {
  baseName: string;
  isDirty: boolean;
  isReadOnly: boolean;
}

export const AccountNumber: React.FC<IAccountNumberProps> = ({ baseName, isDirty, isReadOnly }) => {
  const [accountNumberField, accountNumberMeta] = useField<string | undefined>(`${baseName}.accountNumber`);

  const [confirmAccountNumberField, confirmAccountNumberMeta] = useField(`${baseName}.accountNumberConfirmation`);

  return (
    <>
      <StyledPaddedInputField
        label={<Label>Account Number</Label>}
        control={
          <Input
            {...accountNumberField}
            onCopy={(e) => {
              e.preventDefault();
              toast('Not allowed to copy account number', { type: 'warning' });
            }}
            autoComplete={'off'}
          />
        }
        error={!!accountNumberMeta.error}
        description={<FormHelp>{accountNumberMeta.error}</FormHelp>}
        data-test-id={'account-number'}
        readOnly={isReadOnly}
      />
      {isDirty && !!accountNumberField.value && (
        <StyledInputField
          label={<Label>Confirm Account Number</Label>}
          control={<Input {...confirmAccountNumberField} autoComplete={'off'} />}
          error={!!confirmAccountNumberMeta.error}
          description={<FormHelp>{confirmAccountNumberMeta.error}</FormHelp>}
          data-test-id={'confirm-account-number'}
        />
      )}
    </>
  );
};

const StyledInputField = styled(FormField)`
  flex-basis: 33%;
`;

const StyledPaddedInputField = styled(StyledInputField)`
  padding-right: 2rem;
`;
